<template>
  <div :style="indent">
    <div @click="toggleChildren" :class="['flex', 'justify-between', 'items-start', 'px-4', 'py-3', 'text-base', 'font-medium', 'rounded-md', 'cursor-pointer', 'group', 'md:px-2', 'md:py-1', 'md:text-sm',
      ...(searchQuery.includes(query)
        ? ['bg-gray-900', 'text-white']
        : ['text-gray-300', 'hover:bg-gray-700', 'hover:text-white'])]" v-if="amount === undefined">

      <div class="flex items-start flex-1 pr-2">
        <component :is="icon" :class="['mr-3', 'md:mr-2', 'flex-shrink-0', 'h-6', 'w-6', 'md:h-4', 'md:w-4', 'mt-0.5']" aria-hidden="true" />
        <span class="leading-tight break-words">{{ label }}</span>
      </div>

      <ChevronDownIcon :class="['flex-shrink-0', 'h-5', 'w-5', 'md:h-4', 'md:w-4', 'mt-0.5']" v-if="showChildren" />
      <ChevronUpIcon :class="['flex-shrink-0', 'h-5', 'w-5', 'md:h-4', 'md:w-4', 'mt-0.5']" v-if="!showChildren" />
    </div>

    <div v-else :class="[
      'flex justify-between items-start px-4 py-3 text-base font-medium rounded-md group cursor-pointer md:px-2 md:py-1 md:text-sm',
      ...(searchQuery.includes(query)
        ? ['bg-gray-900', 'text-white']
        : ['text-gray-300', 'hover:bg-gray-700', 'hover:text-white']),
    ]" @click="filterClicked(query)">

      <div class="relative flex items-start flex-1 pr-2">
        <span v-if="icon" @mouseover="showTooltip(`tooltip-${icon}`, $event)" class="flex-shrink-0 w-6 h-6 mr-3 md:w-5 md:h-5 md:mr-2 mt-0.5" v-html="getIcon(icon)"></span>

        <span class="leading-tight break-words">{{ label }}</span>

        <div v-if="icon" :id="`tooltip-${icon}`" class="max-w-[200px] inline-block absolute invisible z-50 py-2.5 px-3 text-sm font-medium text-black bg-gray-200 shadow-lg border border-1 border-gray-300 rounded-lg opacity-0 transition-opacity duration-300 tooltip">
          {{ $t("alarms.sidebar." + icon) }}
          <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
      </div>

      <span v-if="amount || amount == 0" :class="[navigationTextColor(color), 'flex-shrink-0 mt-0.5']">
        ({{ amount }})
      </span>
    </div>
  </div>

  <template v-if="showChildren">
    <NavigationTree v-for="node in nodes" v-bind:key="node.name" :nodes="node.subItems" :label="node.name" :depth="depth + 1" :hash="node.hash" :icon="node.icon" :color="node.color" :amount="node.amount" :query="node.query" :searchQuery="searchQuery">
    </NavigationTree>
  </template>
</template>

<script>
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/solid";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getIcon } from "@/lib/alarms";
import { Tooltip } from "flowbite";

export default {
  name: "NavigationTree",

  components: {
    ChevronDownIcon,
    ChevronUpIcon,
  },

  props: ["label", "nodes", "depth", "hash", "icon", "amount", "color", "query", "searchQuery"],
  data() {
    return {
      showChildren: true,
      tooltips: {}
    };
  },

  setup() {
    const store = useStore();
    const { t } = useI18n();

    return { store, t, getIcon };
  },
  computed: {
    indent() {
      if (this.depth > 1) return { margin: `0 0 0 ${this.depth * 20}px` };

      return { margin: `0 0 0 ${this.depth * 25}px` };
    },
  },
  methods: {
    toggleChildren() {
      this.showChildren = !this.showChildren;
    },
    navigationTextColor(color) {
      if (color == "green") {
        return "text-green-300";
      } else if (color == "orange") {
        return "text-orange-300";
      } else if (color == "red") {
        return "text-red-300";
      } else if (color == "yellow") {
        return "text-yellow-100";
      } else {
        return "text-gray-300";
      }
    },
    filterClicked(filter) {
      this.$store.dispatch("addFilterToSearch", filter);
    },
    showTooltip(targetElId, event) {
      const options = {
        placement: 'right',
        triggerType: 'hover',
      }
      const targetEl = document.getElementById(targetElId);

      if (!this.tooltips[targetElId]) {
        this.tooltips[targetElId] = new Tooltip(targetEl, event.target, options);
      }
    }
  },
};
</script>
